import React, { useState, useEffect } from "react";
// import { useHistory } from "react-router-dom";
// import { useDispatch } from "react-redux";
// import { toast } from "react-toastify";

// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
import InputLabel from "@material-ui/core/InputLabel";
import Select from '@material-ui/core/Select';
import FormControl from "@material-ui/core/FormControl";
import MenuItem from '@material-ui/core/MenuItem';
import TextField from "@material-ui/core/TextField";
import Autocomplete from "@material-ui/lab/Autocomplete";
import { Backdrop, Checkbox, CircularProgress, FormControlLabel, TextareaAutosize } from '@material-ui/core';

// core components
import GridItem from "../../Grid/GridItem.js";
import GridContainer from "../../Grid/GridContainer.js";
import CustomInput from "../../CustomInput/CustomInput.js";
import Button from "../../CustomButtons/Button.js";
import Card from "../../Card/Card.js";
import CardHeader from "../../Card/CardHeader.js";
import CardAvatar from "../../Card/CardAvatar.js";
import CardBody from "../../Card/CardBody.js";
import CardFooter from "../../Card/CardFooter.js";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

// API imports removed for design-only version
// import { addregister, getreligionlist, getregislist, getcastelist, getmaritallist, getcolorlist, getstarlist, getzodiaclist, getdirectionlist } from "../../actions/users";

const useStyles = makeStyles((theme) => ({
  formControl: {
    margin: theme.spacing(1),
    minWidth: 120
  },
  selectEmpty: {
    marginTop: theme.spacing(2)
  },
  cardCategoryWhite: {
    color: "rgba(255, 255, 255, 1)",
    margin: "0",
    fontSize: "14px",
    marginTop: "0",
    marginBottom: "0",
  },
  textDanger: {
    color: "rgb(148,44,174)",
  },
  cardTitleWhite: {
    color: "#FFFFFF",
    marginTop: "0px",
    minHeight: "auto",
    fontWeight: "300",
    fontFamily: "'Roboto', 'Helvetica', 'Arial', sans-serif",
    marginBottom: "3px",
    textDecoration: "none",
  },
  GridItem: {
    margin: "10px",
  },
  formLabel: {
    fontSize: "2rem",
  }
}));

// toaster config removed
// toast.configure();

const initialFormValue = {
  // personal detail
  phone_number: "",
  mname: "",
  religion: "",
  subcaste: "",
  height: "",
  educ: "",
  w_place: "",
  different: "",
  handireason: "",
  bestgod: "",
  date: "",
  month: "",
  year: "",
  sex: "",
  castename: "",
  birth_time: "",
  occup: "",
  income: "",
  children: "",
  child_detail: "",
  colorname: "",
  maritalname: "",

  // Family detail
  father_name: "",
  mother_name: "",
  dad_work: "",
  mom_work: "",
  brother: "",
  m_brother: "",
  sister: "",
  m_sister: "",
  regis: "",
  puriveaam: "",
  livesity: "",
  dever: "",
  peroparty: "",
  pob: "",

  // horscope detail
  starname: "",
  patham: "",
  zodiacname: "",
  gothra: "",
  directionname: "",
  s_year: "",
  s_month: "",
  s_day: "",
  r1: "", r2: "", r3: "", r4: "", r5: "", r6: "",
  r7: "", r8: "", r9: "", r10: "", r11: "", r12: "",
  a1: "", a2: "", a3: "", a4: "", a5: "", a6: "",
  a7: "", a8: "", a9: "", a10: "", a11: "", a12: "",

  //contact details
  address: "",
  city: "",
  mobile_number: "",
  email_id: "",
  comment: "",
  jathagampic: "",
};

const occupations = [
  { title: "CxO / Chairman / Director / President", value: "CxO / Chairman / Director / President" },
  { title: "VP / AVP / GM / DGM", value: "VP / AVP / GM / DGM" },
  { title: "Sr. Manager / Manager", value: "Sr. Manager / Manager" },
  { title: "Consultant / Supervisor / Team Leads", value: "Consultant / Supervisor / Team Leads" },
  { title: "Team Member / Staff", value: "Team Member / Staff" },

  { title: "Air Hostess / Flight Attendant", value: "Air Hostess / Flight Attendant" },
  { title: "Pilot / Co-Pilot", value: "Pilot / Co-Pilot" },

  { title: "Architect", value: "Architect" },
  { title: "Interior Designer", value: "Interior Designer" },
  { title: "Landscape Architect", value: "Landscape Architect" },

  { title: "Animator", value: "Animator" },
  { title: "Commercial Artist", value: "Commercial Artist" },
  { title: "Web / UX Designers", value: "Web / UX Designers" },

  { title: "Beautician", value: "Beautician" },
  { title: "Fashion Designer", value: "Fashion Designer" },
  { title: "Hairstylist", value: "Hairstylist" },
  { title: "Jewellery Designer", value: "Jewellery Designer" },

  { title: "Customer Support / BPO / KPO Professional", value: "Customer Support / BPO / KPO Professional" },

  { title: "IAS / IRS / IES / IFS", value: "IAS / IRS / IES / IFS" },
  { title: "Indian Police Services [IPS]", value: "Indian Police Services [IPS]" },

  { title: "Airforce", value: "Airforce" },
  { title: "Army", value: "Army" },
  { title: "Navy", value: "Navy" },

  { title: "Lecturer", value: "Lecturer" },
  { title: "Professor", value: "Professor" },
  { title: "Research Assistant", value: "Research Assistant" },
  { title: "Research Scholar", value: "Research Scholar" },
  { title: "Teacher", value: "Teacher" },

  { title: "Civil Engineer", value: "Civil Engineer" },
  { title: "Electronics / Telecom Engineer", value: "Electronics / Telecom Engineer" },
  { title: "Mechanical / Production Engineer", value: "Mechanical / Production Engineer" },

  { title: "Chef / Sommelier / Food Critic", value: "Chef / Sommelier / Food Critic" },
  { title: "Catering Professional", value: "Catering Professional" },

  { title: "Software Developer / Programmer", value: "Software Developer / Programmer" },
  { title: "Software Consultant", value: "Software Consultant" },
  { title: "Hardware & Networking professional", value: "Hardware & Networking professional" },

  { title: "Lawyer", value: "Lawyer" },
  { title: "Legal Assistant", value: "Legal Assistant" },

  { title: "Dentist", value: "Dentist" },
  { title: "Doctor", value: "Doctor" },
  { title: "Medical Transcriptionist", value: "Medical Transcriptionist" },
  { title: "Nurse", value: "Nurse" },
  { title: "Pharmacist", value: "Pharmacist" },
  { title: "Physician Assistant", value: "Physician Assistant" },
  { title: "Physiotherapist / Occupational Therapist", value: "Physiotherapist / Occupational Therapist" },
  { title: "Psychologist", value: "Psychologist" },
  { title: "Surgeon", value: "Surgeon" },
  { title: "Veterinary Doctor", value: "Veterinary Doctor" },

  { title: "Merchant Naval Officer", value: "Merchant Naval Officer" },
  { title: "Mariner", value: "Mariner" },

  { title: "Marketing Professional", value: "Marketing Professional" },
  { title: "Sales Professional", value: "Sales Professional" },

  { title: "Biologist / Botanist", value: "Biologist / Botanist" },
  { title: "Physicist", value: "Physicist" },
  { title: "No Job", value: "No Job" },
  { title: "Others", value: "Others" },
];

// Sort the occupations array by category
occupations.sort((a, b) => {
  if (a.category < b.category) {
    return -1;
  }
  if (a.category > b.category) {
    return 1;
  }
  return 0;
});

const educationOptions = [
  { title: "High School", value: "High School" },
  { title: "Higher Secondary", value: "Higher Secondary" },
  { title: "Diploma", value: "Diploma" },
  { title: "Bachelor's Degree", value: "Bachelor's Degree" },
  { title: "Master's Degree", value: "Master's Degree" },
  { title: "MBA", value: "MBA" },
  { title: "MCA", value: "MCA" },
  { title: "B.Tech", value: "B.Tech" },
  { title: "M.Tech", value: "M.Tech" },
  { title: "MBBS", value: "MBBS" },
  { title: "MD", value: "MD" },
  { title: "PhD", value: "PhD" },
  { title: "CA (Chartered Accountant)", value: "CA" },
  { title: "CS (Company Secretary)", value: "CS" },
  { title: "ICWA", value: "ICWA" },
  { title: "LLB", value: "LLB" },
  { title: "LLM", value: "LLM" },
  { title: "B.Arch", value: "B.Arch" },
  { title: "M.Arch", value: "M.Arch" },
  { title: "B.Sc", value: "B.Sc" },
  { title: "M.Sc", value: "M.Sc" },
  { title: "B.Com", value: "B.Com" },
  { title: "M.Com", value: "M.Com" },
  { title: "BA", value: "BA" },
  { title: "MA", value: "MA" },
  { title: "BBA", value: "BBA" },
  { title: "BCA", value: "BCA" },
  { title: "Other", value: "Other" },
];

const nmarriage = [
  { title: "Divorce", value: "Divorce" },
  { title: "Widow", value: "Widow" },
];

const childrens = [
  { title: "Yes", value: "Yes" },
  { title: "No", value: "No" },
];

const incomeRanges = [
  { value: "0-5", title: "₹0 to ₹5 Lakh yearly" },
  { value: "5-10", title: "₹5 Lakh to ₹10 Lakh yearly" },
  { value: "10-15", title: "₹10 Lakh to ₹15 Lakh yearly" },
  { value: "15-20", title: "₹15 Lakh to ₹20 Lakh yearly" },
  { value: "20-25", title: "₹20 Lakh to ₹25 Lakh yearly" },
  { value: "25-30", title: "₹25 Lakh to ₹30 Lakh yearly" },
  { value: "30-35", title: "₹30 Lakh to ₹35 Lakh yearly" },
  { value: "35-40", title: "₹35 Lakh to ₹40 Lakh yearly" },
  { value: "40-45", title: "₹40 Lakh to ₹45 Lakh yearly" },
  { value: "45-50", title: "₹45 Lakh to ₹50 Lakh yearly" },
  { value: "50-55", title: "₹50 Lakh to ₹55 Lakh yearly" },
  { value: "55-60", title: "₹55 Lakh to ₹60 Lakh yearly" },
  { value: "60-65", title: "₹60 Lakh to ₹65 Lakh yearly" },
  { value: "65-70", title: "₹65 Lakh to ₹70 Lakh yearly" },
  { value: "70-75", title: "₹70 Lakh to ₹75 Lakh yearly" },
  { value: "75-80", title: "₹75 Lakh to ₹80 Lakh yearly" },
  { value: "80-85", title: "₹80 Lakh to ₹85 Lakh yearly" },
  { value: "85-90", title: "₹85 Lakh to ₹90 Lakh yearly" },
  { value: "90-95", title: "₹90 Lakh to ₹95 Lakh yearly" },
  { value: "95-100", title: "₹95 Lakh to ₹1 Cr yearly" },
  { value: "100+", title: "₹1 Cr+ yearly" },
  { value: "prefer-not-to-say", title: "Prefer not to say" }
];

const sectors = [
  { title: "Private Sector - IT/Software", value: "Private Sector - IT/Software" },
  { title: "Private Sector - MNC", value: "Private Sector - MNC" },
  { title: "Private Sector - Corporate", value: "Private Sector - Corporate" },
  { title: "Private Sector - Others", value: "Private Sector - Others" },

  { title: "Government - Central Government", value: "Government - Central Government" },
  { title: "Government - State Government", value: "Government - State Government" },
  { title: "Government - PSU (Public Sector Undertaking)", value: "Government - PSU" },
  { title: "Government - Defence", value: "Government - Defence" },
  { title: "Government - Others", value: "Government - Others" },

  { title: "Business / Self-Employed", value: "Business / Self-Employed" },
  { title: "Not Working", value: "Not Working" },
  { title: "Others", value: "Others" },
];

export default function AgentNewRegistration() {
  const classes = useStyles();
  // const history = useHistory();
  // const dispatch = useDispatch();

  const [userdet, setUser] = useState();
  const [formValue, setFormValue] = useState(initialFormValue);
  const [validateError, setValidateError] = useState({});

  const [idpass, setidpass] = useState('61fe0d29b9938726b92dcb44')
  const [castenone, setcastenone] = useState(false);
  const [dhosams, setdhosam] = useState();
  const [timeattach, settimeattach] = useState("");
  // const [maritals, setmarital] = useState();
  const [districts, setdistricts] = useState();
  const [loading, setloading] = useState(false);

  const [childdetail, setchild] = useState("none");
  const [remarriage, setUnmarried] = useState("none");
  const [handyreason, setdifferent] = useState("none");

  // Static data for dropdowns (instead of API calls)
  const [options, setoption] = useState([
    { title: "Register 1", value: "Register 1" },
    { title: "Register 2", value: "Register 2" },
  ]);
  const [colors, setcolor] = useState([
    { title: "Fair", value: "Fair" },
    { title: "Wheatish", value: "Wheatish" },
    { title: "Dark", value: "Dark" },
  ]);
  const [religions, setreligion] = useState([
    { title: "Hindu", value: "Hindu" },
    { title: "Muslim", value: "Muslim" },
    { title: "Christian", value: "Christian" },
  ]);
  const [castes, setcaste] = useState([
    { title: "Caste 1", value: "Caste 1" },
    { title: "Caste 2", value: "Caste 2" },
  ]);
  const [maritals, setmarital] = useState([
    { title: "Unmarried", value: "Unmarried" },
    { title: "Married", value: "Married" },
    { title: "Divorced", value: "Divorced" },
    { title: "Widowed", value: "Widowed" },
  ]);
  const [stars, setstar] = useState([
    { title: "Ashwini", value: "Ashwini" },
    { title: "Bharani", value: "Bharani" },
    { title: "Krittika", value: "Krittika" },
  ]);
  const [zodiacs, setzodiac] = useState([
    { title: "Aries", value: "Aries" },
    { title: "Taurus", value: "Taurus" },
    { title: "Gemini", value: "Gemini" },
  ]);
  const [directions, setdirection] = useState([
    { title: "North", value: "North" },
    { title: "South", value: "South" },
    { title: "East", value: "East" },
    { title: "West", value: "West" },
  ]);

  const handleFile = (event) => {
    event.preventDefault();
    console.log(event.target.files[0]);
    const { id, files } = event.target;
    let formData = { ...formValue, ...{ [id]: files.length == 1 ? files[0] : files } };
    setFormValue(formData);
  };

  const onChange = (e) => {
    e.preventDefault();
    console.log(e.target);
    const { id, value } = e.target;
    let formData = { ...formValue, ...{ [id]: value } };
    setFormValue(formData);
    console.log(formValue);
  };

  const dayoption = [];
  for (let i = 1; i <= 31; i++) {
    dayoption.push(i);
  }

  const monthoption = [];
  for (let i = 1950; i <= 2030; i++) {
    monthoption.push(i);
  }

  const {
    phone_number, mname, religion, subcaste, height, educ, w_place, different,
    handireason, bestgod, date, month, year, sex, castename, birth_time, occup,
    income, children, child_detail, colorname, maritalname,
    father_name, mother_name, dad_work, mom_work, brother, m_brother, sister,
    m_sister, regis, puriveaam, livesity, dever, peroparty, pob,
    starname, patham, zodiacname, gothra, directionname, s_year, s_month, s_day,
    r1, r2, r3, r4, r5, r6, r7, r8, r9, r10, r11, r12,
    a1, a2, a3, a4, a5, a6, a7, a8, a9, a10, a11, a12,
    address, city, photopath, jathagampic, mobile_number, email_id, comment, age,
  } = formValue;

  const handleFormSubmit = (e) => {
    e.preventDefault();
    console.log("Form submitted with values:", formValue);

    // API call removed - Design only version
    alert("Form submitted successfully! (Design-only mode - no API call made)\\nCheck console for form data.");

    // You can see all form data in browser console
  };

  const brothers = [
    { title: "0", value: "0" }, { title: "1", value: "1" }, { title: "2", value: "2" },
    { title: "3", value: "3" }, { title: "4", value: "4" }, { title: "5", value: "5" },
    { title: "6", value: "6" }, { title: "7", value: "7" }, { title: "8", value: "8" },
    { title: "9", value: "9" }, { title: "10", value: "10" }, { title: "11", value: "11" },
    { title: "12", value: "12" },
  ];

  const mbrothers = [
    { title: "0", value: "0" }, { title: "1", value: "1" }, { title: "2", value: "2" },
    { title: "3", value: "3" }, { title: "4", value: "4" }, { title: "5", value: "5" },
    { title: "6", value: "6" }, { title: "7", value: "7" }, { title: "8", value: "8" },
    { title: "9", value: "9" }, { title: "10", value: "10" }, { title: "11", value: "11" },
    { title: "12", value: "12" },
  ];

  const sisters = [
    { title: "0", value: "0" }, { title: "1", value: "1" }, { title: "2", value: "2" },
    { title: "3", value: "3" }, { title: "4", value: "4" }, { title: "5", value: "5" },
    { title: "6", value: "6" }, { title: "7", value: "7" }, { title: "8", value: "8" },
    { title: "9", value: "9" }, { title: "10", value: "10" }, { title: "11", value: "11" },
    { title: "12", value: "12" },
  ];

  const msisters = [
    { title: "0", value: "0" }, { title: "1", value: "1" }, { title: "2", value: "2" },
    { title: "3", value: "3" }, { title: "4", value: "4" }, { title: "5", value: "5" },
    { title: "6", value: "6" }, { title: "7", value: "7" }, { title: "8", value: "8" },
    { title: "9", value: "9" }, { title: "10", value: "10" }, { title: "11", value: "11" },
    { title: "12", value: "12" },
  ];

  const heights = [
    { title: "4ft 5in", value: "4ft 5in" }, { title: "4ft 6in", value: "4ft 6in" },
    { title: "4ft 7in", value: "4ft 7in" }, { title: "4ft 8in", value: "4ft 8in" },
    { title: "4ft 9in", value: "4ft 9in" }, { title: "4ft 10in", value: "4ft 10in" },
    { title: "4ft 11in", value: "4ft 11in" }, { title: "5ft", value: "5ft" },
    { title: "5ft 1in", value: "5ft 1in" }, { title: "5ft 2in", value: "5ft 2in" },
    { title: "5ft 3in", value: "5ft 3in" }, { title: "5ft 4in", value: "5ft 4in" },
    { title: "5ft 5in", value: "5ft 5in" }, { title: "5ft 6in", value: "5ft 6in" },
    { title: "5ft 7in", value: "5ft 7in" }, { title: "5ft 8in", value: "5ft 8in" },
    { title: "5ft 9in", value: "5ft 9in" }, { title: "5ft 10in", value: "5ft 10in" },
    { title: "5ft 11in", value: "5ft 11in" }, { title: "6ft", value: "6ft" },
    { title: "6ft 1in", value: "6ft 1in" }, { title: "6ft 2in", value: "6ft 2in" },
    { title: "6ft 3in", value: "6ft 3in" }, { title: "6ft 4in", value: "6ft 4in" },
    { title: "6ft 5in", value: "6ft 5in" }, { title: "6ft 6in", value: "6ft 6in" },
    { title: "6ft 7in", value: "6ft 7in" }, { title: "6ft 8in", value: "6ft 8in" },
    { title: "6ft 9in", value: "6ft 9in" }, { title: "6ft 10in", value: "6ft 10in" },
    { title: "6ft 11in", value: "6ft 11in" }, { title: "7ft", value: "7ft" },
  ];

  const sexch = [
    { title: "Male", value: "Male" },
    { title: "Female", value: "Female" },
  ];

  const differents = [
    { title: "Yes", value: "Yes" },
    { title: "No", value: "No" },
  ];

  const pathams = [
    { title: "0", value: "0" }, { title: "1", value: "1" }, { title: "2", value: "2" },
    { title: "3", value: "3" }, { title: "4", value: "4" },
  ];

  // getUserData function removed - using static data instead
  const getUserData = () => {
    console.log("Using static dropdown data - no API calls");
    // All dropdown data is already set in useState hooks above
  };

  const add = () => {
    console.log("Navigation removed - design only mode");
    // window.location = "/admin/registeradd";
  };

  useEffect(() => {
    getUserData();
  }, []);

  const handleTimeChange = (date) => {
    if (date) {
      const formattedTime = `${date.getHours().toString().padStart(2, "0")}:${date
        .getMinutes()
        .toString()
        .padStart(2, "0")}`;

      setFormValue((prev) => ({
        ...prev,
        time_of_birth: formattedTime,
      }));
    } else {
      setFormValue((prev) => ({ ...prev, time_of_birth: "" }));
    }
  }

  return (
    <div>
      <div className="page_header">
        {/* <div>
          <Button
            className="ml-3"
            variant="contained"
            color="primary"
            onClick={add}
          >
            Switch to English
          </Button>
        </div> */}
      </div>
      <GridContainer>
        <GridItem xs={12} sm={12} md={12}>
          <Card>
            <form
              className={classes.form}
              noValidate
              onSubmit={handleFormSubmit}
            >
              <CardHeader color="primary" style={{ backgroundColor: "black !important" }}>
                <h2 class="font-great-vibes" style={{ margin: '0px 20px', color: '#ffffff' }}>
                  Registration Form
                </h2>
                <p className={classes.cardCategoryWhite}>Create a new registration</p>
              </CardHeader>
              <CardBody>
                <Card>
                  {/* <CardHeader color="rose">
                    <h4 className={classes.cardTitleWhite}>1.Personal Details</h4>
                  </CardHeader> */}
                  <CardBody>
                    <GridContainer>

                      <GridItem xs={12} sm={12} md={6}>
                        {/* <label> Name <span>*</span></label> */}
                        <TextField
                          fullWidth
                          InputLabelProps={{
                            shrink: true,
                            className: classes.formLabel,
                          }}
                          color="black"
                          label="Phone Number"
                          labelColor="black"
                          value={phone_number}
                          onChange={onChange}
                          id="phone_number"
                          formControlProps={{
                            fullWidth: true,
                          }}
                        />
                        {validateError.phone_number && (
                          <span className={classes.textDanger}>
                            {validateError.phone_number}
                          </span>
                        )}
                      </GridItem>

                      <GridItem xs={12} sm={12} md={6}>
                        <TextField
                          fullWidth
                          InputLabelProps={{
                            shrink: true,
                            className: classes.formLabel,
                          }}
                          label="Place of Birth"
                          id="place_of_birth"
                          formControlProps={{
                            fullWidth: true,
                          }}
                        />
                      </GridItem>

                      <GridItem xs={12} sm={12} md={6}>
                        <TextField
                          fullWidth
                          InputLabelProps={{
                            shrink: true,
                            className: classes.formLabel,
                          }}
                          label="Place of Residence"
                          id="place_of_residence"
                          formControlProps={{
                            fullWidth: true,
                          }}
                        />
                      </GridItem>

                      <GridItem xs={12} sm={12} md={6}>
                        <div style={{ flex: 1 }}>
                          <DatePicker
                            selected={formValue.dob ? new Date(formValue.dob) : null}
                            onChange={(date) => {
                              setFormValue((prev) => ({ ...prev, dob: date }));
                            }}
                            dateFormat="dd/MM/yyyy"
                            maxDate={new Date()}
                            showYearDropdown
                            dropdownMode="select"
                            wrapperClassName="custom-wrapper"
                            customInput={
                              <TextField
                                fullWidth
                                label="Date of Birth"
                                error={!!validateError.dob}
                                helperText={validateError.dob}
                                variant="outlined"
                                sx={{
                                  '& .MuiInputBase-input': {
                                    fontSize: '16px',
                                    padding: '16px',
                                    height: '17px',
                                  }
                                }}
                                FormHelperTextProps={{
                                  style: { fontSize: "14px", color: "red" },
                                }}
                              />
                            }
                          />
                        </div>
                      </GridItem>

                      <GridItem xs={12} sm={12} md={6}>
                        <div style={{ flex: 1 }}>
                          <DatePicker
                            selected={formValue.time_of_birth
                              ? new Date(`1970-01-01T${formValue.time_of_birth}:00`)
                              : null}
                            onChange={handleTimeChange}
                            showTimeSelect
                            showTimeSelectOnly
                            timeIntervals={15}
                            timeCaption="Time"
                            dateFormat="h:mm aa"
                            placeholderText="Select time"
                            popperClassName="large-time-picker-popper"
                            wrapperClassName="custom-wrapper"
                            customInput={
                              <TextField
                                fullWidth
                                label="Time of Birth"
                                error={!!validateError.time_of_birth}
                                helperText={validateError.time_of_birth}
                                variant="outlined"
                                sx={{
                                  '& .MuiInputBase-input': {
                                    fontSize: '16px',
                                    padding: '16px',
                                    height: '17px',
                                  },
                                }}
                                FormHelperTextProps={{
                                  style: { fontSize: "14px", color: "red" },
                                }}
                              />
                            }
                          />
                        </div>

                      </GridItem>

                      <GridItem xs={12} sm={12} md={6}>
                        <Autocomplete
                          options={religions}
                          // noOptionsText="Enter to create a new option"
                          value={religions.length ? religion : ""}
                          getOptionLabel={(option) => option.title}
                          onChange={(event, newValue) => {
                            // console.log("religion",newValue);
                            console.log(newValue.value, "hariiiiiii");
                            if (newValue.value) {
                              let formData = {
                                ...formValue,
                                ...{ ["religion"]: newValue },
                              };
                              console.log(formData, "sdgfgs");
                              setidpass(newValue.value)

                              setFormValue(formData);

                            }
                          }}
                          type="text"
                          name="religion"
                          renderInput={(params) => (
                            <TextField
                              fullWidth
                              InputLabelProps={{
                                shrink: true,
                              }}
                              {...params}
                              label="Religion"
                              variant="outlined"
                            />
                          )}
                        />
                        {validateError.religion && (
                          <span className={classes.textDanger}>
                            {validateError.religion}
                          </span>
                        )}
                      </GridItem>

                      <GridItem xs={12} sm={12} md={6}>
                        <Autocomplete
                          options={castes}
                          // noOptionsText="Enter to create a new option"
                          getOptionLabel={(option) => option.title}
                          onChange={(event, newValue) => {
                            // console.log("caste", newValue.value);
                            if (newValue.value) {
                              let formData = {
                                ...formValue,
                                ...{ ["castename"]: newValue.value },
                              };
                              setFormValue(formData);

                            }
                          }}
                          type="text"
                          name="castename"
                          renderInput={(params) => (
                            <TextField
                              fullWidth
                              InputLabelProps={{
                                shrink: true,
                              }}
                              {...params}
                              label="Caste"
                              variant="outlined"
                            />
                          )}
                        />

                        {validateError.castename && (
                          <span className={classes.textDanger}>
                            {validateError.castename}
                          </span>
                        )}

                      </GridItem>
                      <GridItem xs={12} sm={12} md={6}>
                        <TextField
                          fullWidth
                          InputLabelProps={{
                            shrink: true,
                            className: classes.formLabel,
                          }}
                          label="Subcaste"

                          // value={subcaste}
                          id="subcaste"
                          formControlProps={{
                            fullWidth: true,
                          }}
                        />
                        {validateError.subcaste && (
                          <span className={classes.textDanger}>
                            {validateError.subcaste}
                          </span>
                        )}
                      </GridItem>



                      <GridItem xs={12} sm={12} md={6}>
                        {/* <label> Name <span>*</span></label> */}
                        <TextField
                          fullWidth
                          InputLabelProps={{
                            shrink: true,
                            className: classes.formLabel,
                          }}
                          label="Name"
                          id="mname"
                          // name="mname" 
                          formControlProps={{
                            fullWidth: true,
                          }}
                        />
                        {validateError.mname && (
                          <span className={classes.textDanger}>
                            {validateError.mname}
                          </span>
                        )}
                      </GridItem>

                      <GridItem xs={12} sm={12} md={6}>

                        <Autocomplete
                          options={sexch}
                          // noOptionsText="Enter to create a new option"
                          getOptionLabel={(option) => option.title}
                          onChange={(event, newValue) => {
                            console.log(newValue.value);

                            let formData = {
                              ...formValue,
                              ...{ ["sex"]: newValue.value },
                            };
                            setFormValue(formData);

                          }}
                          type="text"
                          name="sex"
                          renderInput={(params) => (
                            <TextField
                              fullWidth
                              InputLabelProps={{
                                shrink: true,
                              }}
                              {...params}
                              label="Gender"
                              variant="outlined"
                            />
                          )}
                        />

                        {validateError.sex && (
                          <span className={classes.textDanger}>
                            {validateError.sex}
                          </span>
                        )}

                      </GridItem>





                      <GridItem xs={12} sm={12} md={6}>
                        <Autocomplete
                          options={heights}
                          // noOptionsText="Enter to create a new option"
                          getOptionLabel={(option) => option.title}
                          onChange={(event, newValue) => {
                            console.log(newValue.value);
                            let formData = {
                              ...formValue,
                              ...{ ["height"]: newValue.value },
                            };
                            setFormValue(formData);
                          }}
                          type="text"
                          name="height"
                          renderInput={(params) => (
                            <TextField
                              fullWidth
                              InputLabelProps={{
                                shrink: true,
                              }}
                              {...params}
                              label="Height"
                              variant="outlined"
                            />
                          )}
                        />

                        {validateError.height && (
                          <span className={classes.textDanger}>
                            {validateError.height}
                          </span>
                        )}

                      </GridItem>
                      <GridItem xs={12} sm={12} md={6}>
                        <Autocomplete
                          options={colors}
                          // noOptionsText="Enter to create a new option"
                          getOptionLabel={(option) => option.title}
                          onChange={(event, newValue) => {
                            // console.log(newValue.value);
                            if (newValue.value) {
                              let formData = {
                                ...formValue,
                                ...{ ["colorname"]: newValue.value },
                              };
                              setFormValue(formData);
                            }
                          }}
                          type="text"
                          name="colorname"
                          renderInput={(params) => (
                            <TextField
                              fullWidth
                              InputLabelProps={{
                                shrink: true,
                              }}
                              {...params}
                              label="Color"
                              variant="outlined"
                            />
                          )}
                        />

                        {validateError.colorname && (
                          <span className={classes.textDanger}>
                            {validateError.colorname}
                          </span>
                        )}
                      </GridItem>

                      <GridItem xs={12} sm={12} md={6}>
                        <Autocomplete
                          options={educationOptions}
                          // noOptionsText="Enter to create a new option"
                          getOptionLabel={(option) => option.title}
                          onChange={(event, newValue) => {
                            // console.log(newValue.value);
                            if (newValue.value) {
                              let formData = {
                                ...formValue,
                                ...{ ["educ"]: newValue.value },
                              };
                              setFormValue(formData);
                            }
                          }}
                          type="text"
                          name="educ"
                          renderInput={(params) => (
                            <TextField
                              id="educ"
                              fullWidth
                              InputLabelProps={{
                                shrink: true,
                              }}
                              {...params}
                              label="Education"
                              variant="outlined"
                            />
                          )}
                        />

                        {validateError.educ && (
                          <span className={classes.textDanger}>
                            {validateError.educ}
                          </span>
                        )}
                      </GridItem>

                      {/* <GridItem xs={12} sm={12} md={6}>
                        <TextField
                          fullWidth
                          InputLabelProps={{
                            shrink: true,
                          }}
                          label="Education"

                          id="educ"
                          // value={educ}
                          formControlProps={{
                            fullWidth: true,
                          }}
                        />
                        {validateError.educ && (
                          <span className={classes.textDanger}>
                            {validateError.educ}
                          </span>
                        )}
                      </GridItem> */}

                      <GridItem xs={12} sm={12} md={6}>
                        <TextField
                          fullWidth
                          InputLabelProps={{
                            shrink: true,
                            className: classes.formLabel,
                          }}
                          label="Higher Education Qualification"
                          id="higher_education_qualification"
                          formControlProps={{
                            fullWidth: true,
                          }}
                        />
                        {validateError.higher_education_qualification && (
                          <span className={classes.textDanger}>
                            {validateError.higher_education_qualification}
                          </span>
                        )}
                      </GridItem>

                      <GridItem xs={12} sm={12} md={6}>
                        <Autocomplete
                          options={occupations}
                          // noOptionsText="Enter to create a new option"
                          getOptionLabel={(option) => option.title}
                          onChange={(event, newValue) => {
                            // console.log(newValue.value);
                            if (newValue.value) {
                              let formData = {
                                ...formValue,
                                ...{ ["occup"]: newValue.value },
                              };
                              setFormValue(formData);
                            }
                          }}
                          type="text"
                          name="occup"
                          renderInput={(params) => (
                            <TextField
                              id="occup"
                              fullWidth
                              InputLabelProps={{
                                shrink: true,
                              }}
                              {...params}
                              label="Occupation"
                              variant="outlined"
                            />
                          )}
                        />

                        {validateError.occup && (
                          <span className={classes.textDanger}>
                            {validateError.occup}
                          </span>
                        )}
                      </GridItem>

                      {/* <GridItem xs={12} sm={12} md={6}>
                        <TextField
                          fullWidth
                          InputLabelProps={{
                            shrink: true,
                          }}
                          label="Occupation"
                          // name="occup"
                          id="occup"
                          // value={occup}
                          formControlProps={{
                            fullWidth: true,
                          }}
                        />
                        {validateError.occup && (
                          <span className={classes.textDanger}>
                            {validateError.occup}
                          </span>
                        )}
                      </GridItem> */}

                      <GridItem xs={12} sm={12} md={6}>
                        <TextField
                          fullWidth
                          InputLabelProps={{
                            shrink: true,
                            className: classes.formLabel,
                          }}
                          label="Father's Name "

                          // value={father_name}
                          id="father_name"
                          formControlProps={{
                            fullWidth: true,
                          }}
                        />
                        {validateError.father_name && (
                          <span className={classes.textDanger}>
                            {validateError.father_name}
                          </span>
                        )}
                      </GridItem>

                      <GridItem xs={12} sm={12} md={6}>
                        <TextField
                          fullWidth
                          InputLabelProps={{
                            shrink: true,
                            className: classes.formLabel,
                          }}
                          label="Father Occupation"

                          // value={dad_work}
                          id="dad_work"
                          formControlProps={{
                            fullWidth: true,
                          }}
                        />
                        {validateError.dad_work && (
                          <span className={classes.textDanger}>
                            {validateError.dad_work}
                          </span>
                        )}
                      </GridItem>



                      <GridItem xs={12} sm={12} md={6}>
                        <TextField
                          fullWidth
                          InputLabelProps={{
                            shrink: true,
                            className: classes.formLabel,
                          }}
                          label="Mother's Name"

                          // value={mother_name}
                          id="mother_name"
                          formControlProps={{
                            fullWidth: true,
                          }}
                        />
                        {validateError.mother_name && (
                          <span className={classes.textDanger}>
                            {validateError.mother_name}
                          </span>
                        )}
                      </GridItem>

                      <GridItem xs={12} sm={12} md={6}>
                        <TextField
                          fullWidth
                          InputLabelProps={{
                            shrink: true,
                            className: classes.formLabel,
                          }}
                          label="Mother Occupation"

                          // value={dad_work}
                          id="mom_work"
                          formControlProps={{
                            fullWidth: true,
                          }}
                        />
                        {validateError.mom_work && (
                          <span className={classes.textDanger}>
                            {validateError.mom_work}
                          </span>
                        )}
                      </GridItem>



                      <GridItem xs={12} sm={12} md={6}>
                        <Autocomplete
                          options={brothers}
                          // noOptionsText="Enter to create a new option"
                          getOptionLabel={(option) => option.title}
                          onChange={(event, newValue) => {
                            console.log(newValue.value);
                            let formData = {
                              ...formValue,
                              ...{ ["brother"]: newValue.value },
                            };
                            setFormValue(formData);
                          }}
                          type="text"
                          name="brother"
                          renderInput={(params) => (
                            <TextField
                              fullWidth
                              InputLabelProps={{
                                shrink: true,
                              }}
                              {...params}
                              label="Brothers"
                              variant="outlined"
                            />
                          )}
                        />

                        {validateError.brother && (
                          <span className={classes.textDanger}>
                            {validateError.brother}
                          </span>
                        )}

                      </GridItem>

                      <GridItem xs={12} sm={12} md={6}>
                        <Autocomplete
                          options={mbrothers}
                          // noOptionsText="Enter to create a new option"
                          getOptionLabel={(option) => option.title}
                          onChange={(event, newValue) => {
                            console.log(newValue.value);
                            let formData = {
                              ...formValue,
                              ...{ ["m_brother"]: newValue.value },
                            };
                            setFormValue(formData);
                          }}
                          type="text"
                          name="m_brother"
                          renderInput={(params) => (
                            <TextField
                              fullWidth
                              InputLabelProps={{
                                shrink: true,
                              }}
                              {...params}
                              label="Married Brothers"
                              variant="outlined"
                            />
                          )}
                        />

                        {validateError.m_brother && (
                          <span className={classes.textDanger}>
                            {validateError.m_brother}
                          </span>
                        )}

                      </GridItem>

                      <GridItem xs={12} sm={12} md={6}>
                        <Autocomplete
                          options={sisters}
                          // noOptionsText="Enter to create a new option"
                          getOptionLabel={(option) => option.title}
                          onChange={(event, newValue) => {
                            console.log(newValue.value);
                            let formData = {
                              ...formValue,
                              ...{ ["sister"]: newValue.value },
                            };
                            setFormValue(formData);
                          }}
                          type="text"
                          name="sister"
                          renderInput={(params) => (
                            <TextField
                              fullWidth
                              InputLabelProps={{
                                shrink: true,
                              }}
                              {...params}
                              label="Sisters"
                              variant="outlined"
                            />
                          )}
                        />


                        {validateError.sister && (
                          <span className={classes.textDanger}>
                            {validateError.sister}
                          </span>
                        )}
                      </GridItem>

                      <GridItem xs={12} sm={12} md={6}>
                        <Autocomplete
                          options={msisters}
                          // noOptionsText="Enter to create a new option"
                          getOptionLabel={(option) => option.title}
                          onChange={(event, newValue) => {
                            console.log(newValue.value);
                            let formData = {
                              ...formValue,
                              ...{ ["m_sister"]: newValue.value },
                            };
                            setFormValue(formData);
                          }}
                          type="text"
                          name="m_sister"
                          renderInput={(params) => (
                            <TextField
                              fullWidth
                              InputLabelProps={{
                                shrink: true,
                              }}
                              {...params}
                              label="Married Sisters"
                              variant="outlined"
                            />
                          )}
                        />

                        {validateError.m_sister && (
                          <span className={classes.textDanger}>
                            {validateError.m_sister}
                          </span>
                        )}

                      </GridItem>

                      <GridItem xs={12} sm={12} md={6}>
                        <Autocomplete
                          options={differents}
                          // noOptionsText="Enter to create a new option"
                          value={different}
                          getOptionLabel={(option) => option.title}
                          onChange={(event, newValue) => {
                            if (newValue.value == "No") {

                              setdifferent("none");

                            } else {
                              setdifferent("block");
                            }
                            console.log(newValue.value);
                            let formData = {
                              ...formValue,
                              ...{ ["different"]: newValue },
                            };
                            setFormValue(formData);
                          }}
                          type="text"
                          name="different"
                          renderInput={(params) => (
                            <TextField
                              fullWidth
                              InputLabelProps={{
                                shrink: true,
                              }}
                              {...params}
                              label="Differently Abled"
                              variant="outlined"
                            />
                          )}
                        />

                        {validateError.different && (
                          <span className={classes.textDanger}>
                            {validateError.different}
                          </span>
                        )}

                      </GridItem>



                      <GridItem xs={12} sm={12} md={6}>
                        <Autocomplete
                          options={maritals}
                          // noOptionsText="Enter to create a new option"
                          getOptionLabel={(option) => option.title}
                          value={maritalname}
                          onChange={(event, newValue) => {
                            // console.log(newValue.value,"marital");
                            if (newValue.value == "Marriage") {

                              setUnmarried("none");

                            } else {
                              setUnmarried("block");
                            }

                            let formData = {
                              ...formValue,
                              ...{ ["maritalname"]: newValue },
                            };
                            setFormValue(formData);

                          }}
                          type="text"
                          name="maritalname"
                          renderInput={(params) => (
                            <TextField
                              fullWidth
                              InputLabelProps={{
                                shrink: true,
                              }}
                              {...params}
                              label="Marital Status"
                              variant="outlined"
                            />
                          )}
                        />
                        {validateError.maritalname && (
                          <span className={classes.textDanger}>
                            {validateError.maritalname}
                          </span>
                        )}

                      </GridItem>

                      <GridItem xs={12} sm={12} md={6} style={{ display: handyreason }}>
                        <TextField
                          fullWidth
                          InputLabelProps={{
                            shrink: true,
                          }}
                          label="Description"

                          id="handireason"
                          // value={handireason}
                          formControlProps={{
                            fullWidth: true,
                          }}
                        />
                        {validateError.handireason && (
                          <span className={classes.textDanger}>
                            {validateError.handireason}
                          </span>
                        )}
                      </GridItem>


                      <GridItem xs={12} sm={12} md={6} style={{ display: remarriage }}>
                        <Autocomplete
                          options={nmarriage}
                          // noOptionsText="Enter to create a new option"
                          getOptionLabel={(option) => option.title}
                          onChange={(event, newValue) => {
                            console.log(newValue.value);
                            let formData = {
                              ...formValue,
                              ...{ ["n_marriage"]: newValue.value },
                            };
                            setFormValue(formData);
                          }}
                          type="text"
                          name="nmarriage"
                          renderInput={(params) => (
                            <TextField
                              fullWidth
                              InputLabelProps={{
                                shrink: true,
                              }}
                              {...params}
                              label="Reason for Remarriage"
                              variant="outlined"
                            />
                          )}
                        />

                        {validateError.n_marriage && (
                          <span className={classes.textDanger}>
                            {validateError.n_marriage}
                          </span>
                        )}

                      </GridItem>

                      <GridItem xs={12} sm={12} md={6} style={{ display: remarriage }}>
                        <Autocomplete
                          options={childrens}
                          // noOptionsText="Enter to create a new option"
                          getOptionLabel={(option) => option.title}
                          onChange={(event, newValue) => {

                            if (newValue.value == "No") {

                              setchild("none");

                            } else {
                              setchild("block");
                            }
                            console.log(newValue.value);
                            let formData = {
                              ...formValue,
                              ...{ ["children"]: newValue.value },
                            };
                            setFormValue(formData);
                          }}
                          type="text"
                          name="children"
                          renderInput={(params) => (
                            <TextField
                              fullWidth
                              InputLabelProps={{
                                shrink: true,
                              }}
                              {...params}
                              label="Children"
                              variant="outlined"
                            />
                          )}
                        />

                        {validateError.children && (
                          <span className={classes.textDanger}>
                            {validateError.children}
                          </span>
                        )}

                      </GridItem>

                      <GridItem xs={12} sm={12} md={6} style={{ display: childdetail }}>
                        <TextField
                          fullWidth
                          InputLabelProps={{
                            shrink: true,
                          }}
                          label="Children details"

                          // value={child_detail}
                          id="child_detail"
                          formControlProps={{
                            fullWidth: true,
                          }}
                        />
                        {validateError.child_detail && (
                          <span className={classes.textDanger}>
                            {validateError.child_detail}
                          </span>
                        )}
                      </GridItem>

                      <GridItem xs={12} sm={12} md={6}>
                        <Autocomplete
                          options={incomeRanges}
                          getOptionLabel={(option) => option.title}
                          onChange={(event, newValue) => {
                            console.log(newValue.value);
                            let formData = {
                              ...formValue,
                              ...{ ["income"]: newValue ? newValue.value : "" },
                            };
                            setFormValue(formData);
                          }}
                          type="text"
                          name="income"
                          renderInput={(params) => (
                            <TextField
                              fullWidth
                              InputLabelProps={{
                                shrink: true,
                              }}
                              {...params}
                              label="Income Range"
                              variant="outlined"
                            />
                          )}
                        />
                        {validateError.income && (
                          <span className={classes.textDanger}>
                            {validateError.income}
                          </span>
                        )}
                      </GridItem>

                      <GridItem xs={12} sm={12} md={6}>
                        <TextField
                          fullWidth
                          InputLabelProps={{
                            shrink: true,
                            className: classes.formLabel,
                          }}
                          label="Company Name"
                          id="company_name"
                          formControlProps={{
                            fullWidth: true,
                          }}
                        />
                      </GridItem>

                      <GridItem xs={12} sm={12} md={6}>
                        <Autocomplete
                          options={sectors}
                          getOptionLabel={(option) => option.title}
                          onChange={(event, newValue) => {
                            console.log(newValue.value);
                            let formData = {
                              ...formValue,
                              ...{ ["work_sector"]: newValue ? newValue.value : "" },
                            };
                            setFormValue(formData);
                          }}
                          type="text"
                          name="work_sector"
                          renderInput={(params) => (
                            <TextField
                              fullWidth
                              InputLabelProps={{
                                shrink: true,
                              }}
                              {...params}
                              label="Sector"
                              variant="outlined"
                            />
                          )}
                        />
                        {validateError.work_sector && (
                          <span className={classes.textDanger}>
                            {validateError.work_sector}
                          </span>
                        )}
                      </GridItem>
                      {/* <GridItem xs={12} sm={12} md={6}>
                        <TextField
                          fullWidth
                          InputLabelProps={{
                            shrink: true,
                          }}
                          label="Work Sector"
                          id="work_sector"
                          formControlProps={{
                            fullWidth: true,
                          }}
                        />
                      </GridItem> */}

                      <GridItem xs={12} sm={12} md={6}>
                        <TextField
                          fullWidth
                          InputLabelProps={{
                            shrink: true,
                            className: classes.formLabel,
                          }}
                          label="Workplace"
                          id="w_place"
                          formControlProps={{
                            fullWidth: true,
                          }}
                        />
                        {validateError.w_place && (
                          <span className={classes.textDanger}>
                            {validateError.w_place}
                          </span>
                        )}
                      </GridItem>

                      <GridItem xs={12} sm={12} md={6}>
                        <TextField
                          fullWidth
                          InputLabelProps={{
                            shrink: true,
                            className: classes.formLabel,
                          }}
                          label="Residence"

                          // value={livesity}
                          id="livesity"
                          formControlProps={{
                            fullWidth: true,
                          }}
                        />
                        {validateError.livesity && (
                          <span className={classes.textDanger}>
                            {validateError.livesity}
                          </span>
                        )}
                      </GridItem>

                      <GridItem xs={12} sm={12} md={6}>
                        <TextField
                          fullWidth
                          InputLabelProps={{
                            shrink: true,
                            className: classes.formLabel,
                          }}
                          label="Family Order"

                          // value={dever}
                          id="dever"
                          formControlProps={{
                            fullWidth: true,
                          }}
                        />
                        {validateError.dever && (
                          <span className={classes.textDanger}>
                            {validateError.dever}
                          </span>
                        )}
                      </GridItem>

                      <GridItem xs={12} sm={12} md={6}>
                        <TextField
                          fullWidth
                          InputLabelProps={{
                            shrink: true,
                            className: classes.formLabel,
                          }}
                          label="Assets"

                          // value={peroparty}
                          id="peroparty"
                          formControlProps={{
                            fullWidth: true,
                          }}
                        />
                        {validateError.peroparty && (
                          <span className={classes.textDanger}>
                            {validateError.peroparty}
                          </span>
                        )}
                      </GridItem>

                      <GridItem xs={12} sm={12} md={6}>
                        <TextField
                          fullWidth
                          InputLabelProps={{
                            shrink: true,
                            className: classes.formLabel,
                          }}
                          label="Expectation"

                          // value={pob}
                          id="pob"
                          formControlProps={{
                            fullWidth: true,
                          }}
                        />
                        {validateError.pob && (
                          <span className={classes.textDanger}>
                            {validateError.pob}
                          </span>
                        )}
                      </GridItem>

                      <GridItem xs={12} sm={12} md={6}>
                        <TextField
                          fullWidth
                          InputLabelProps={{
                            shrink: true,
                            className: classes.formLabel,
                          }}
                          label="Family Deity"

                          // value={bestgod}
                          id="bestgod"
                          formControlProps={{
                            fullWidth: true,
                          }}
                        />
                        {validateError.bestgod && (
                          <span className={classes.textDanger}>
                            {validateError.bestgod}
                          </span>
                        )}
                      </GridItem>
                    </GridContainer>
                  </CardBody>

                  <CardBody>

                    <GridContainer>
                      <GridItem xs={12} sm={12} md={6}>
                        <Autocomplete
                          options={stars}
                          noOptionsText="Enter to create a new option"
                          getOptionLabel={(option) => option.title}
                          onChange={(event, newValue) => {
                            // console.log(newValue.value);
                            let formData = {
                              ...formValue,
                              ...{ ["starname"]: newValue.value },
                            };
                            setFormValue(formData);
                          }}
                          type="text"
                          name="starname"
                          renderInput={(params) => (
                            <TextField
                              fullWidth
                              InputLabelProps={{
                                shrink: true,
                              }}
                              {...params}
                              label="Star"
                              variant="outlined"
                            />
                          )}
                        />

                        {validateError.starname && (
                          <span className={classes.textDanger}>
                            {validateError.starname}
                          </span>
                        )}

                      </GridItem>
                      <GridItem xs={12} sm={12} md={6}>
                        <Autocomplete
                          options={pathams}
                          // noOptionsText="Enter to create a new option"
                          getOptionLabel={(option) => option.title}
                          onChange={(event, newValue) => {
                            console.log(newValue.value);
                            let formData = {
                              ...formValue,
                              ...{ ["patham"]: newValue.value },
                            };
                            setFormValue(formData);
                          }}
                          type="text"
                          name="patham"
                          renderInput={(params) => (
                            <TextField
                              fullWidth
                              InputLabelProps={{
                                shrink: true,
                              }}
                              {...params}
                              label="Patham"
                              variant="outlined"
                            />
                          )}
                        />


                        {validateError.patham && (
                          <span className={classes.textDanger}>
                            {validateError.patham}
                          </span>
                        )}

                      </GridItem>
                    </GridContainer>

                    <GridContainer>
                      <GridItem xs={12} sm={12} md={6}>
                        <Autocomplete
                          options={zodiacs}
                          // noOptionsText="Enter to create a new option"
                          getOptionLabel={(option) => option.title}
                          onChange={(event, newValue) => {
                            console.log(newValue.value);
                            let formData = {
                              ...formValue,
                              ...{ ["zodiacname"]: newValue.value },
                            };
                            setFormValue(formData);
                          }}
                          type="text"
                          name="zodiacname"
                          renderInput={(params) => (
                            <TextField
                              fullWidth
                              InputLabelProps={{
                                shrink: true,
                              }}
                              {...params}
                              label="Zodiac"
                              variant="outlined"
                            />
                          )}
                        />

                        {validateError.zodiacname && (
                          <span className={classes.textDanger}>
                            {validateError.zodiacname}
                          </span>
                        )}

                      </GridItem>
                      <GridItem xs={12} sm={12} md={6}>
                        <Autocomplete
                          options={zodiacs}
                          // noOptionsText="Enter to create a new option"
                          getOptionLabel={(option) => option.title}
                          onChange={(event, newValue) => {
                            console.log(newValue.value);
                            let formData = {
                              ...formValue,
                              ...{ ["gothra"]: newValue.value },
                            };
                            setFormValue(formData);
                          }}
                          type="text"
                          name="gothra"
                          renderInput={(params) => (
                            <TextField
                              fullWidth
                              InputLabelProps={{
                                shrink: true,
                              }}
                              {...params}
                              label="Lagnam"
                              variant="outlined"
                            />
                          )}
                        />

                        {validateError.gothra && (
                          <span className={classes.textDanger}>
                            {validateError.gothra}
                          </span>
                        )}

                      </GridItem>
                    </GridContainer>

                    <GridContainer>
                      <GridItem xs={12} sm={12} md={12}>
                        <img src={require('../../../assests/images/chat_new_en.png')}></img>
                      </GridItem>
                    </GridContainer>

                    <GridContainer>
                      <GridItem xs={12} sm={12} md={12} style={{ display: 'flex', justifyContent: 'center' }}>
                        <div class="form-group table-responsive">
                          <GridItem>
                            <table class="rassi-table">
                              <tbody>
                                <tr>
                                  <td>
                                    <TextareaAutosize

                                      // value={r1}
                                      id="r1"
                                      aria-label="minimum height"
                                      minRows={3}
                                      Cols={8}
                                      formControlProps={{
                                        fullWidth: true,
                                      }} />
                                  </td>
                                  <td>
                                    <TextareaAutosize

                                      // value={r2}
                                      id="r2"
                                      aria-label="minimum height"
                                      minRows={3}
                                      Cols={8}
                                      formControlProps={{
                                        fullWidth: true,
                                      }} />
                                  </td>
                                  <td>
                                    <TextareaAutosize

                                      // value={r3}
                                      id="r3"
                                      aria-label="minimum height"
                                      minRows={3}
                                      Cols={8}
                                      formControlProps={{
                                        fullWidth: true,
                                      }} />
                                  </td>
                                  <td>
                                    <TextareaAutosize

                                      // value={r4}
                                      id="r4"
                                      aria-label="minimum height"
                                      minRows={3}
                                      Cols={8}
                                      formControlProps={{
                                        fullWidth: true,
                                      }} />
                                  </td>
                                  <GridItem></GridItem>
                                  <td>
                                    <TextareaAutosize

                                      // value={a1}
                                      id="a1"
                                      aria-label="minimum height"
                                      minRows={3}
                                      Cols={8}
                                      formControlProps={{
                                        fullWidth: true,
                                      }} />
                                  </td>
                                  <td>
                                    <TextareaAutosize

                                      // value={a2}
                                      id="a2"
                                      aria-label="minimum height"
                                      minRows={3}
                                      Cols={8}
                                      formControlProps={{
                                        fullWidth: true,
                                      }} />
                                  </td>
                                  <td>
                                    <TextareaAutosize

                                      // value={a3}
                                      id="a3"
                                      aria-label="minimum height"
                                      minRows={3}
                                      Cols={8}
                                      formControlProps={{
                                        fullWidth: true,
                                      }} />
                                  </td>
                                  <td>
                                    <TextareaAutosize

                                      // value={a4}
                                      id="a4"
                                      aria-label="minimum height"
                                      minRows={3}
                                      Cols={8}
                                      formControlProps={{
                                        fullWidth: true,
                                      }} />
                                  </td>
                                </tr>
                                <tr>
                                  <td>
                                    <TextareaAutosize

                                      // value={r5}
                                      id="r5"
                                      aria-label="minimum height"
                                      minRows={3}
                                      Cols={8}
                                      formControlProps={{
                                        fullWidth: true,
                                      }} />
                                  </td>
                                  <td colspan="2" rowspan="2" width="124" align="center">
                                    <img src={require('../../../assests/images/raaasi_en.png')}></img>
                                  </td>
                                  <td><TextareaAutosize

                                    // value={r6}
                                    id="r6"
                                    aria-label="minimum height"
                                    minRows={3}
                                    Cols={8}
                                    formControlProps={{
                                      fullWidth: true,
                                    }} />
                                  </td>
                                  <GridItem></GridItem>
                                  <td>
                                    <TextareaAutosize

                                      // value={a5}
                                      id="a5"
                                      aria-label="minimum height"
                                      minRows={3}
                                      Cols={8}
                                      formControlProps={{
                                        fullWidth: true,
                                      }} />
                                  </td>
                                  <td rowspan="2" colspan="2" width="133" align="center">
                                    <img src={require('../../../assests/images/amsam_en.png')}></img>
                                  </td>
                                  <td>
                                    <TextareaAutosize

                                      // value={a6}
                                      id="a6"
                                      aria-label="minimum height"
                                      minRows={3}
                                      Cols={8}
                                      formControlProps={{
                                        fullWidth: true,
                                      }} />
                                  </td>
                                </tr>
                                <tr>
                                  <td>
                                    <TextareaAutosize

                                      // value={r7}
                                      id="r7"
                                      aria-label="minimum height"
                                      minRows={3}
                                      Cols={8}
                                      formControlProps={{
                                        fullWidth: true,
                                      }} />
                                  </td>
                                  <td>
                                    <TextareaAutosize

                                      // value={r8}
                                      id="r8"
                                      aria-label="minimum height"
                                      minRows={3}
                                      Cols={8}
                                      formControlProps={{
                                        fullWidth: true,
                                      }} />
                                  </td>
                                  <GridItem></GridItem>
                                  <td>
                                    <TextareaAutosize

                                      // value={a7}
                                      id="a7"
                                      aria-label="minimum height"
                                      minRows={3}
                                      Cols={8}
                                      formControlProps={{
                                        fullWidth: true,
                                      }} />
                                  </td>
                                  <td align="center">
                                    <TextareaAutosize

                                      // value={a8}
                                      id="a8"
                                      aria-label="minimum height"
                                      minRows={3}
                                      Cols={8}
                                      formControlProps={{
                                        fullWidth: true,
                                      }} />
                                  </td>
                                </tr>
                                <tr>
                                  <td>
                                    <TextareaAutosize

                                      // value={r9}
                                      id="r9"
                                      aria-label="minimum height"
                                      minRows={3}
                                      Cols={8}
                                      formControlProps={{
                                        fullWidth: true,
                                      }} />
                                  </td>
                                  <td>
                                    <TextareaAutosize

                                      // value={r10}
                                      id="r10"
                                      aria-label="minimum height"
                                      minRows={3}
                                      Cols={8}
                                      formControlProps={{
                                        fullWidth: true,
                                      }} />
                                  </td>
                                  <td>
                                    <TextareaAutosize

                                      // value={r11}
                                      id="r11"
                                      aria-label="minimum height"
                                      minRows={3}
                                      Cols={8}
                                      formControlProps={{
                                        fullWidth: true,
                                      }} />
                                  </td>
                                  <td>
                                    <TextareaAutosize

                                      // value={r12}
                                      id="r12"
                                      aria-label="minimum height"
                                      minRows={3}
                                      Cols={8}
                                      formControlProps={{
                                        fullWidth: true,
                                      }} />
                                  </td>
                                  <GridItem></GridItem>
                                  <td>
                                    <TextareaAutosize

                                      // value={a9}
                                      id="a9"
                                      aria-label="minimum height"
                                      minRows={3}
                                      Cols={8}
                                      formControlProps={{
                                        fullWidth: true,
                                      }} />
                                  </td>
                                  <td>
                                    <TextareaAutosize

                                      // value={a10}
                                      id="a10"
                                      aria-label="minimum height"
                                      minRows={3}
                                      Cols={8}
                                      formControlProps={{
                                        fullWidth: true,
                                      }} />
                                  </td>
                                  <td>
                                    <TextareaAutosize

                                      // value={a11}
                                      id="a11"
                                      aria-label="minimum height"
                                      minRows={3}
                                      Cols={8}
                                      formControlProps={{
                                        fullWidth: true,
                                      }} />
                                  </td>
                                  <td>
                                    <TextareaAutosize

                                      // value={a12}
                                      id="a12"
                                      aria-label="minimum height"
                                      minRows={3}
                                      Cols={8}
                                      formControlProps={{
                                        fullWidth: true,
                                      }} />
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </GridItem>
                        </div>
                      </GridItem>

                    </GridContainer>

                  </CardBody>

                  <CardHeader color="primary">
                    <h2 className={classes.cardTitleWhite}>Additional Information</h2>
                  </CardHeader>

                  <CardBody>
                    <GridContainer>
                      <GridItem xs={12} sm={12} md={6}>
                        <Autocomplete
                          options={options}
                          // noOptionsText="Enter to create a new option"
                          getOptionLabel={(option) => option.title}
                          onChange={(event, newValue) => {
                            console.log(newValue.value);
                            let formData = {
                              ...formValue,
                              ...{ ["regis"]: newValue.value },
                            };
                            setFormValue(formData);
                          }}
                          type="text"
                          name="regis"
                          renderInput={(params) => (
                            <TextField
                              fullWidth
                              InputLabelProps={{
                                shrink: true,
                              }}
                              {...params}
                              label="Register by"
                              variant="outlined"
                            />
                          )}
                        />
                        {validateError.regis && (
                          <span className={classes.textDanger}>
                            {validateError.regis}
                          </span>
                        )}
                      </GridItem>











                      <GridItem xs={12} sm={12} md={6}>
                        <TextField
                          fullWidth
                          InputLabelProps={{
                            shrink: true,
                            className: classes.formLabel,
                          }}
                          label="Additional phone number"

                          id="mobile_number"
                          // value={email_id}
                          formControlProps={{
                            fullWidth: true,
                          }}
                        />
                        {validateError.mobile_number && (
                          <span className={classes.textDanger}>
                            {validateError.mobile_number}
                          </span>
                        )}
                      </GridItem>

                      <GridItem xs={12} sm={12} md={6}>
                        <TextField
                          fullWidth
                          InputLabelProps={{
                            shrink: true,
                            className: classes.formLabel,
                          }}
                          label="Email Address"

                          id="email_id"
                          // value={email_id}
                          formControlProps={{
                            fullWidth: true,
                          }}
                        />
                        {validateError.email_id && (
                          <span className={classes.textDanger}>
                            {validateError.email_id}
                          </span>
                        )}
                      </GridItem>

                      <GridItem xs={12} sm={12} md={6}>
                        <TextField
                          fullWidth
                          InputLabelProps={{
                            shrink: true,
                            className: classes.formLabel,
                          }}
                          label="Address"

                          id="address"
                          // value={address}
                          formControlProps={{
                            fullWidth: true,
                          }}
                        />
                        {validateError.address && (
                          <span className={classes.textDanger}>
                            {validateError.address}
                          </span>
                        )}
                      </GridItem>
                      <GridItem xs={12} sm={12} md={6}>
                        <Autocomplete
                          options={districts}
                          // noOptionsText="Enter to create a new option"
                          getOptionLabel={(option) => option.title}
                          onChange={(event, newValue) => {
                            // console.log("caste", newValue.value);
                            if (newValue.value) {
                              let formData = {
                                ...formValue,
                                ...{ ["city"]: newValue.value },
                              };
                              setFormValue(formData);

                            }
                          }}
                          type="text"
                          name="city"
                          renderInput={(params) => (
                            <TextField
                              fullWidth
                              InputLabelProps={{
                                shrink: true,
                              }}
                              {...params}
                              label="District"
                              variant="outlined"
                            />
                          )}
                        />

                        {validateError.city && (
                          <span className={classes.textDanger}>
                            {validateError.city}
                          </span>
                        )}

                      </GridItem>

                      <GridItem xs={12} sm={12} md={6}>
                        <TextField
                          fullWidth
                          InputLabelProps={{
                            shrink: true,
                            className: classes.formLabel,
                          }}
                          label="Native Place"
                          id="native_place"
                          formControlProps={{
                            fullWidth: true,
                          }}
                        />
                        {validateError.native_place && (
                          <span className={classes.textDanger}>
                            {validateError.native_place}
                          </span>
                        )}
                      </GridItem>

                      <GridItem xs={12} sm={12} md={6}>
                        {/* <InputLabel style={{ color: "#AAAAAA" }}>
                          Photo
                        </InputLabel> */}
                        <TextField
                          fullWidth
                          InputLabelProps={{
                            shrink: true,
                            className: classes.formLabel,
                          }}
                          label="Photo"
                          onChange={handleFile}
                          id="photopath"
                          type="file"
                          inputProps={{
                            multiple: true,
                          }}
                          formControlProps={{
                            fullWidth: true,
                          }}
                        />
                        {/* <ReactCrop src={src} crop={crop} onChange={newCrop => setCrop(newCrop)} />
                        <button
                          className="btn btn-primary btn-sm"
                          onClick={getCroppedImg}
                          onChange={handleFile}
                          style={{ marginRight: "5px" }}
                        >
                          Crop
                        </button> */}

                        {/* {croppedImageUrl && (
                          <img alt="Crop" style={{ maxWidth: '100%' }} src={croppedImageUrl} />
                        )} */}

                        {validateError.photopath && (
                          <span className={classes.textDanger}>
                            {validateError.photopath}
                          </span>
                        )}
                      </GridItem>

                      <GridItem xs={12} sm={12} md={6}>
                        {/* <InputLabel style={{ color: "#AAAAAA" }}>
                          Horoscope Photo
                        </InputLabel> */}
                        <TextField
                          fullWidth
                          InputLabelProps={{
                            shrink: true,
                            className: classes.formLabel,
                          }}
                          label="Horoscope Photo"
                          onChange={handleFile}
                          id="jathgampic"
                          type="file"
                          formControlProps={{
                            fullWidth: true,
                          }}
                        />

                        {validateError.jathgampic && (
                          <span className={classes.textDanger}>
                            {validateError.jathgampic}
                          </span>
                        )}
                      </GridItem>
                    </GridContainer>
                    <GridContainer>
                      <GridItem xs={12} sm={12} md={12}>
                        <TextField
                          fullWidth
                          InputLabelProps={{
                            shrink: true,
                            className: classes.formLabel,
                          }}
                          label="Please describe yourself in brief! like what type of person you are!"
                          minRows={3} multiline
                          id="comment"
                          // value={comment}
                          formControlProps={{
                            fullWidth: true,
                          }}
                        />
                        {validateError.comment && (
                          <span className={classes.textDanger}>
                            {validateError.comment}
                          </span>
                        )}
                      </GridItem>

                    </GridContainer>
                  </CardBody>
                </Card>
              </CardBody>
              <CardFooter>
                <Button color="primary" type="submit">
                  Submit
                </Button>
              </CardFooter>
            </form>
          </Card>
        </GridItem>
      </GridContainer>
      <Backdrop className={classes.backdrop} open={loading} style={{ zIndex: 23 }}>
        <CircularProgress color="inherit" />
      </Backdrop>
    </div>
  );
}